import { Box, Container, Group, Button, Flex, Title } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../config/RoutesName';

const PageNotFound = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate(ROUTES.HOME);
  };

  return (
    <>
      <Container>
        <Box>
          <Group position='center'>
            <Box display={'flex'} ta='center' mih={'65vh'} style={{ justifyContent: 'center', alignItems: 'center' }}>
              <Flex direction='column'>
                <Title order={1} fz={60}>
                  {404}
                </Title>
                <Title order={2}>Page Not Found</Title>
                <Group pt={'40px'}>
                  <Button size={'xl'} w={'100%'} fz={20} onClick={goHome} variant='filled' color='red' radius='11px'>
                    Home
                  </Button>
                </Group>
              </Flex>
            </Box>
          </Group>
        </Box>
      </Container>
    </>
  );
};

export default PageNotFound;
